<ngx-spinner [name]="'vincular-promocao-lote'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Vincular promoções em lote</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <div class="row">
            <div class="col-auto">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Grupo promocional</mat-label>
                    <mat-select [(ngModel)]="grupoSelecionado" name="grupo" required
                        (ngModelChange)="carregarClientes()">
                        <mat-option *ngFor="let grupo of aGruposPromocionais" [value]="grupo">
                            {{grupo.Nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-sm-2" *ngIf="bExibirClientes">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Quantidade mínima para o desconto</mat-label>
                    <input type="number" matInput [(ngModel)]="quantidadeMinima" max="9999999" min="1" readonly>
                </mat-form-field>
            </div>

            <div class="col-sm-2" *ngIf="bExibirClientes">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Desconto em %</mat-label>
                    <input matInput currencyMask
                        [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                        [(ngModel)]="porcentagemDesconto" required>

                    <mat-hint align="end">Desconto entre 1,00% a 50,00%
                    </mat-hint>
                </mat-form-field>

            </div>

            <div class="col-sm" *ngIf="bExibirClientes && selection.selected.length > 0">
                <button class="mt-4" mat-flat-button color="primary" (click)="salvar()">
                    <mat-icon>check</mat-icon> Confirmar alteração
                </button>
            </div>
        </div>

        <div *ngIf="bExibirClientes">

            <div class="row mt-2">
                <div class="col-sm">
                    Produtos: {{sProdutos}}
                </div>
            </div>

            <div class="row mt-4 mb-4">
                <div class="col-sm">
                    * Se o cliente for desmarcado, a promoção será removida para ele;
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Filtro</mat-label>
                        <input matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm">
                    <table mat-table [dataSource]="clientesSource" class="mat-elevation-z2">
                        <!-- Checkbox Column -->

                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Nome">
                            <th mat-header-cell *matHeaderCellDef> Nome </th>
                            <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Cidade">
                            <th mat-header-cell *matHeaderCellDef> Cidade </th>
                            <td mat-cell *matCellDef="let element"> {{element.Cidade}} </td>
                        </ng-container>

                        <ng-container matColumnDef="UF">
                            <th mat-header-cell *matHeaderCellDef> UF </th>
                            <td mat-cell *matCellDef="let element"> {{element.UF}} </td>
                        </ng-container>

                        <ng-container matColumnDef="StatusString">
                            <th mat-header-cell *matHeaderCellDef> Status cliente </th>
                            <td mat-cell *matCellDef="let element"> {{element.StatusString}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsListaClientes"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsListaClientes;">
                        </tr>

                        <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="5" style="text-align: center;">Nenhum cliente foi encontrado
                            </td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 15, 20, 25, 100]"></mat-paginator>
                </div>
            </div>
        </div>

    </mat-card-content>
</mat-card>